import { initContract } from '@ts-rest/core';
import { z } from 'zod';
const c = initContract();
/** Mirrors the backend `SimCardDto` — the single source for both apps. */
export const SimCardSchema = z.object({
    id: z.string(),
    iccid: z.string().nullable(),
    imsi: z.string().nullable(),
    serialNumber: z.string().nullable(),
    status: z.string(),
    type: z.string(),
    pinCode: z.string().nullable(),
    pukCode: z.string().nullable(),
    operatorLabel: z.string().nullable(),
    activationCode: z.string().nullable(),
    owner: z.object({ id: z.string(), name: z.string() }).nullable(),
});
export const simCardContract = c.router({
    /** Per-id flat route (the UUID identifies the resource globally). */
    getSimCard: {
        method: 'GET',
        path: '/sim-cards/:simCardId',
        pathParams: z.object({ simCardId: z.string().min(1) }),
        responses: {
            200: SimCardSchema,
        },
        summary: 'Get a SIM card by id',
    },
    /** Listing nested under the organization (scope in the path). */
    listFreeSimCards: {
        method: 'GET',
        path: '/organizations/:organizationId/sim-cards/free',
        pathParams: z.object({ organizationId: z.string().min(1) }),
        query: z.object({ operator: z.string().optional() }),
        responses: {
            200: z.array(SimCardSchema),
        },
        summary: 'List the free SIM cards of an organization',
    },
});
